var $ = require('jquery');

(function (ssm) {
	'use strict';

	var active = {};

	/**
	 * Menu - with visibility controlled via Aria roles.
	 */
	ssm.menu = function (element, options) {
		var $element = $(element);
		var el = $element[0];
		if (!el) return;

		if (el._ssm_menu) {
			return el._ssm_menu;
		}

		options = $.extend({}, $element.data(), options);
		var ctrl = {};

		ctrl.element = $element;
		ctrl.backdrop = (options && options.backdrop) || false;
		ctrl.group = (options && options.group) || 'default';

		var keyboard = ssm.keyboardNavigableList(ctrl.element.is('ul') ? ctrl.element : ctrl.element.find('ul'));
		if (keyboard) {
			// If we seem to be naviable by keyboard focus our first link on show
			ctrl.element.on('menu:show', function (e, caller) {
				if (!caller) return;

				keyboard.focusFirst();
			});
		}

		// Hide the menu on escape
		ctrl.element.on('keydown', function (e) {
			if (e.keyCode === 27) {
				// escape
				e.preventDefault();
				e.stopImmediatePropagation();

				// Return focus to the caller if any
				if (ctrl.caller) {
					$(ctrl.caller).focus();
				}

				// Contract ourselves
				ctrl.contract();
			}
		});

		ctrl.connectTo = function (items) {
			var self = this;
			$(items).on('click', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();

				self.toggle(this);
			});
		};

		ctrl.state = {
			buttons: [],
		};

		ctrl.toggle = function (caller) {
			if (ctrl.element.is(':visible')) {
				this.contract();
				return false;
			} else {
				this.expand(caller);
				return true;
			}
		};

		ctrl.expand = function (caller) {
			if (active[this.group]) {
				active[this.group].contract();
			}

			this.element.trigger('menu:prepare');

			var $caller = $(caller);
			if (caller) {
				//Fix for menu scroll, to not scroll page
				if ($caller.is('#primary-navigation') && $(window).width() < 641) {
					$('body').css({ overflow: 'hidden' });
				}

				this.state.buttons.push($caller.attr('aria-pressed', 'true'));
				$caller.css('z-index', 1000);
				if ($caller.css('position') === 'static') {
					$caller.css('position', 'relative');
				}
			}

			if (this.element.css('position') === 'static') {
				this.element.css('position', 'relative');
			}

			if (caller) {
				$caller.removeClass($caller.attr('data-classes-off') || '').addClass($caller.attr('data-classes-on') || '');
			}

			this.oldTabindex = this.element.attr('tabindex');

			this.element
				.css({
					display: 'block',
					'z-index': 1000,
				})
				.attr('aria-expanded', 'true')
				.attr('tabindex', '-1');

			if (this.backdrop) {
				showBackdrop(this);
			}

			this.caller = $caller[0];
			this.element.trigger('menu:show', this.caller);

			active[this.group] = this;
		};

		ctrl.contract = function () {
			//Fix for menu scroll, to not scroll page
			$('body').css({ overflow: '' });

			var button;
			for (var i = 0; i < this.state.buttons.length; i++) {
				button = this.state.buttons[i];

				button
					.removeAttr('aria-pressed')
					.css({ position: '', 'z-index': '' })
					.removeClass(button.attr('data-classes-on') || '')
					.addClass(button.attr('data-classes-off') || '');
			}
			this.state.buttons.length = 0;

			this.element.css('display', 'none').attr('aria-expanded', 'false').attr('tabindex', this.oldTabindex);

			this.element.trigger('menu:hide');

			delete this.caller;
			hideBackdrop(this);

			active[this.group] = null;
		};

		ctrl.reset = function () {
			this.state.visible = false;

			this.element
				.css({
					display: '',
					position: '',
				})
				.attr('aria-expanded', 'true')
				.attr('tabindex', this.oldTabindex);

			if (active[this.group] === this) {
				active[this.group] = null;
			}

			hideBackdrop(this);
		};

		el._ssm_menu = ctrl;
		return ctrl;
	};

	var showBackdrop = function (menu) {
		if (!menu._backdrop) {
			menu._backdrop = $('<div></div>')
				.css({
					position: 'fixed',
					left: 0,
					top: 0,
					width: '100%',
					height: '100%',
					'z-index': 999,
				})
				.attr('aria-hidden', 'true')
				.on('click', function () {
					menu.contract();
				})
				.insertBefore(menu.element);
		}

		menu._backdrop.show();
	};

	var hideBackdrop = function (menu) {
		if (menu._backdrop) {
			menu._backdrop.hide();
		}
	};

	var navigable = 'a, button, [tabindex]';
	ssm.keyboardNavigableList = function (lists) {
		lists = $(lists);
		if (lists.length === 0) {
			return null;
		}

		var findLink = function (item) {
			var $item = $(item);
			if ($item.is(navigable)) return $item;

			return $item.find(navigable);
		};

		var findLastIn = function (list) {
			var items = $(list).children('li');
			var last = items[items.length - 1];

			return findLink(last);
		};

		var findFirstIn = function (list) {
			var items = $(list).children('li');
			var first = items[0];

			return findLink(first);
		};

		lists.each(function (idx, list) {
			var $list = $(list);

			$list.on('keydown', navigable, function (e) {
				var $this = $(this);
				var $parent = $this.closest('li');
				switch (e.keyCode) {
					case 38: // UP
					case 37: // LEFT
						e.preventDefault();
						e.stopImmediatePropagation();

						var $prev = $parent.prev('li');
						if ($prev.length === 0) {
							var prevList = idx > 0 ? lists[idx - 1] : lists[lists.length - 1];
							findLastIn(prevList).focus();
						} else {
							return findLink($prev).focus();
						}

						return;
					case 40: // DOWN
					case 39: // RIGHT
						e.preventDefault();
						e.stopImmediatePropagation();

						var $next = $parent.next('li');
						if ($next.length === 0) {
							var nextList = idx === lists.length - 1 ? lists[0] : lists[idx + 1];
							findFirstIn(nextList).focus();
						} else {
							findLink($next).focus();
						}
						break;
				}
			});
		});

		return {
			focusFirst: function () {
				findFirstIn(lists[0]).focus();
			},
		};
	};

	$(window).on('scroll', function () {
		var scrollDistance = $(window).scrollTop();
		var headerHeight = $('.header').outerHeight();
		var $crisis = $('.crisis');
		var isMobile = window.matchMedia('(max-width: 640px)').matches;
		var isPortrait = window.matchMedia('(orientation: portrait)').matches;

		if (isMobile && isPortrait) {
			if (scrollDistance > headerHeight) {
				if (!$crisis.hasClass('hide-crisis')) {
					$crisis.addClass('hide-crisis').css('display', 'block');
					$crisis.one('transitionend', function () {
						if ($crisis.hasClass('hide-crisis')) {
							$crisis.css('display', 'none');
						}
					});
				}
			} else {
				if ($crisis.hasClass('hide-crisis')) {
					$crisis.css('display', 'block');
					setTimeout(function () {
						$crisis.removeClass('hide-crisis');
					}, 10);
				}
			}
		}
	});
})(window.ssm);
